import { customCodeRow, runCustomCode } from '../../../shared/custom-code.js'

function executeCustomCodeFile (file) {

  return new Promise((resolve, reject) => {

    let failure = null
    let settled = false
    const url = URL.createObjectURL(new Blob([file.code], { type: 'text/javascript' }))
    const script = document.createElement('script')

    const onError = (event) => {

      if (event.filename && !String(event.filename).startsWith('blob:')) return

      failure = event.error || new Error(event.message || `${file.name} could not run.`)

      if (typeof event.preventDefault === 'function') event.preventDefault()
    }

    const finish = (error) => {

      if (settled) return

      settled = true
      window.removeEventListener('error', onError)
      script.remove()
      URL.revokeObjectURL(url)

      const problem = error || failure

      if (problem) reject(problem)
      else resolve()
    }

    window.addEventListener('error', onError)
    script.async = false
    script.src = url
    script.setAttribute('data-custom-code', file.name || file.uniqueTitle)
    script.onload = () => finish()
    script.onerror = () => finish(failure || new Error(`${file.name} could not run.`))
    document.head.appendChild(script)
  })
}

function runCustomCodeInPage (customCode) {

  return runCustomCode(customCode, executeCustomCodeFile)
}

function runViewLinkCode (code, item, element, kind) {

  const script = typeof code === 'string' ? code : ''

  if (!script.trim()) return Promise.resolve([])

  const node = element && element.nodeType === 1 ? element : null

  window.turbohammerRow = customCodeRow(item)
  window.turbohammerElement = node
  window.turbohammerRowElement = kind === 'row' ? node : null
  window.turbohammerCard = kind === 'card' ? node : null

  return runCustomCodeInPage({
    files: [{ uniqueTitle: 'view_link', name: 'link.js', code: script }]
  })
}

export { runCustomCodeInPage, runViewLinkCode }
